import clsx from "clsx";

// Matches DESIGN.md's console-restraint character: text-only by default (the
// dominant pattern across pages — "No grows yet" etc.), with an optional
// icon/action for the richer upsell-style empty state seen on Dashboard.jsx's
// Pro-gated sections and components/NoDevices.jsx.
export default function EmptyState({ icon, title, description, action, className }) {
  return (
    <div className={clsx("flex flex-col items-center gap-2 py-6 text-center", className)}>
      {icon && <div className="text-2xl">{icon}</div>}
      <div className={clsx("text-gray-500 dark:text-gray-400", title ? "text-sm font-medium text-gray-700 dark:text-gray-200" : "text-sm")}>
        {title ?? description}
      </div>
      {title && description && (
        <div className="max-w-xs text-xs text-gray-400 dark:text-gray-500">{description}</div>
      )}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
